export type Section = {
  title?: string;
  fields: any[];
};
export type Field = {
  id?: string | number;
  name: string | number;
  title: string;
  type: "text" | "radio" | "select";
  options?: string[];
  dataType?: "number" | "string";
  nestedFields?: Field[];
  showIf?: { field: string | number; value: any };
};

export const notPreviouslyApproved = [
  {
    title:
      "Whether service road/slip road already exists at the proposed location?",
    name: "is_service_road_provided",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    title:
      "Whether the retail outlet is on the service road/slip road (and not on the entry/exit ramp of the service road/slip road)?",
    name: "on_slip_road",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    title:
      "Whether the retail outlet satisfies the general conditions of siting, access conditions, drainage, building line, signboards, etc., depending upon road availability?",
    name: "access_criteria_met",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    title:
      "Fuel Station / Wayside Amenity is existing on a road developed earlier but newly notified as National Highway without any access permission from the competent authority in the State/UT concerned, even after the date of notification??",
    name: "is_constructed_without_prior_permission",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    title:
      "Energized fuel stations / commercial operations of a Wayside Amenity that fulfill the prescribed norms are being carried out without obtaining prior permission for grant of access from the Highway Administrator?",
    name: "is_facility_operational",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export const ifExistingSlipRoad: Field[] = [
  {
    name: "is_located_on_service_road",
    title:
      "Whether the private property is on the service/slip road (and not on the entry/exit ramp of the service/slip road):",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    name: "meets_general_access_requirements",
    title:
      "Whether the private property satisfies the general conditions of access, drainage, building lines, sign boards, etc., depending on the availability of the land:",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    name: "total_traffic_per_day",
    title: "Total traffic (incoming and outgoing) per day",
    type: "text",
    dataType: "number",
  },
];

// for Retail whole data
export const sectionsRetail: any[] = [
  // {
  //   title: "Select the type of fuel station allocated to the applicant",
  //   name: "is_coco_fuel_station",
  //   type: "radio",
  // },
  {
    title: "Average Frontage (in metres)",
    name: "plot_length_m",
    type: "text",
    dataType: "number",
  },
  {
    title: "Average Depth (in metres)",
    name: "plot_width_m",
    type: "text",
    dataType: "number",
  },
  {
    title: "Area (in square metres)",
    name: "plot_area",
    type: "text",
    dataType: "number",
  },
  ...notPreviouslyApproved,
];

// for Private whole data
export const sectionPrivate: any[] = [
  {
    title: "Average Frontage (in metres)",
    name: "plot_length_m",
    type: "text",
    dataType: "number",
  },
  {
    title: "Average Depth (in metres)",
    name: "plot_width_m",
    type: "text",
    dataType: "number",
  },
  {
    title: "Area (in square metres)",
    name: "plot_area",
    type: "text",
    dataType: "number",
  },
  ...ifExistingSlipRoad,
];

export const ifUrbanSectionPrivateNoServiceNew: any[] = [
  {
    name: "min_service_road_merging_distance_m",
    title:
      "Please specify the distance between merging points of service road (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_between_access_road_same_carriageway",
    title:
      "Please specify the distance between two access roads (merging/take-off points) on the same carriageway (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_between_access_roads_m",
    title:
      "Please specify the distance between take-off point of access/service road and the median gap or intersection(in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "check_barrier_distance",
    title: "Please specify the distance from Check Barrier",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_rob_flyover_m",
    title:
      "Please specify the distance from the start of ROB / flyover / Railway Level Crossing(in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "entrance_or_exit_width",
    title: "Please specify the width of entrance/exit(in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "turning_curve_radius",
    title: "Please specify the radius of the turning curve(in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "non_turning_curve_radius",
    title: "Please specify the radius of non-turning curve(in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "acceleration_width",
    title: "Please specify the width of the acceleration lane(in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "deceleration_width",
    title: "Please specify the width of the deceleration lane(in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "service_road_width",
    title: "Please specify the width of the service road (in metres)",
    type: "text",
    dataType: "number",
  },
  // {
  //   name: "service_road_length",
  //   title: "Please specify the width provided (in metres)",
  //   type: "text",
  //   dataType: "number",
  // },
  {
    name: "access_connection_crust_composition",
    title: "Please specify the width provided (in metres)",
    type: "text",
  },
  {
    name: "service_road_width",
    title: "Please specify the width of the service road (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "access_road_downward_slope",
    title: "Specify the slope provided (%)",
    type: "text",
    dataType: "number",
  },
  {
    name: "num_of_cultivates",
    title:
      "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
    type: "text",
    dataType: "number",
  },
  {
    name: "total_traffic_per_day",
    title: "Total traffic (incoming and outgoing) per day",
    type: "text",
    dataType: "number",
  },
];

export const ifRuralSectionPrivateNoServiceNew: any[] = [
  {
    name: "min_service_road_merging_distance_m",
    title:
      "Please specify the minimum distance between merging points of a service road (including acceleration and deceleration lanes",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_between_access_road_same_side",
    title:
      "Please specify the distance between two access roads on the same side",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_between_access_roads_m",
    title:
      "Please specify the distance between the take-off point of access/service road and the median gap or intersection",
    type: "text",
    dataType: "number",
  },
  {
    name: "check_barrier_distance",
    title: "Please specify the distance from Check Barrier",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_rob_flyover_m",
    title:
      "Please specify the distance from start of ROB / flyover / grade separator / Railway Level Crossing)",
    type: "text",
    dataType: "number",
  },
  {
    name: "entrance_or_exit_width",
    title: "Please specify the width of the entrance/exit",
    type: "text",
    dataType: "number",
  },
  {
    name: "turning_curve_radius",
    title: "Please specify the radius of the turning curve",
    type: "text",
    dataType: "number",
  },
  {
    name: "non_turning_curve_radius",
    title: "Please specify the radius of the non-turning curve",
    type: "text",
    dataType: "number",
  },
  {
    name: "acceleration_width",
    title: "Please specify the width of the acceleration lane",
    type: "text",
    dataType: "number",
  },
  {
    name: "deceleration_width",
    title: "Please specify the width of the deceleration lane",
    type: "text",
    dataType: "number",
  },
  {
    name: "service_road_width",
    title: "Please specify the width of the service road",
    type: "text",
    dataType: "number",
  },
  // {
  //   name: "service_road_length",
  //   title: "Please specify the length of the service road (in metres)",
  //   type: "text",
  //   dataType: "number",
  // },
  {
    name: "access_connection_crust_composition",
    title: "Please specify the width provided (in metres))",
    type: "text",
  },
  {
    name: "service_road_width",
    title:
      "Please specify the width of Acces Connection/ extended service road",
    type: "text",
    dataType: "number",
  },
  {
    name: "access_road_downward_slope",
    title: "Please specify the downward slope of the access road",
    type: "text",
    dataType: "number",
  },
  {
    name: "num_of_cultivates",
    title:
      "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
    type: "text",
    dataType: "number",
  },
  {
    name: "total_traffic_per_day",
    title: "Total traffic (incoming and outgoing) per day",
    type: "text",
    dataType: "number",
  },
];

export const ifUrbanSectionPrivateCommonNew: any[] = [
  {
    name: "min_service_road_merging_distance_m",
    title: "Please specify the distance between merging points of service road",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_between_access_road_same_carriageway",
    title:
      "Please specify the distance between two access roads (merging/take-off points) on the same carriageway",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_between_access_roads_m",
    title:
      "Please specify the distance between take-off point of access/service road and the median gap or intersection",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_rob_flyover_m",
    title:
      "Please specify the distance from the start of ROB / flyover / Railway Level Crossing",
    type: "text",
    dataType: "number",
  },
  {
    name: "entrance_or_exit_width",
    title: "Please specify the width of entrance/exit",
    type: "text",
    dataType: "number",
  },
  {
    name: "turning_curve_radius",
    title: "Please specify the radius of the turning curve",
    type: "text",
    dataType: "number",
  },
  {
    name: "non_turning_curve_radius",
    title: "Please specify the radius of non-turning curve",
    type: "text",
    dataType: "number",
  },
  {
    name: "acceleration_width",
    title: "Please specify the width of the acceleration lane",
    type: "text",
    dataType: "number",
  },
  {
    name: "deceleration_width",
    title: "Please specify the width of the deceleration lane",
    type: "text",
    dataType: "number",
  },
  {
    name: "service_road_width",
    title: "Please specify the width of the service road (in metres)",
    type: "text",
    dataType: "number",
  },
  // {
  //   name: "service_road_length",
  //   title: "Please specify the length of the service road (in metres)",
  //   type: "text",
  //   dataType: "number",
  // },
  {
    name: "access_road_downward_slope",
    title:
      "Please specify the access road slope towards the intercepting drain",
    type: "text",
    dataType: "number",
  },
  {
    name: "num_of_cultivates",
    title:
      "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
    type: "text",
    dataType: "number",
  },
  {
    name: "total_traffic_per_day",
    title: "Total traffic (incoming and outgoing) per day",
    type: "text",
    dataType: "number",
  },
];

export const ifRuralSectionPrivateCommonNew: any[] = [
  {
    name: "min_service_road_merging_distance_m",
    title:
      "Please specify distance between merging points of service roads including acceleration/deceleration lanes",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_between_access_road_same_side",
    title:
      "Please specify the distance between two access roads (merging/take-off points) on the same carriageway",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_between_access_roads_m",
    title:
      "Please specify the distance between access take-off point and nearest intersection/median gap",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_rob_flyover_m",
    title:
      "Please specify the distance from the start of ROB / flyover / Railway Level Crossing",
    type: "text",
    dataType: "number",
  },
  {
    name: "entrance_or_exit_width",
    title: "Please specify the width of the entrance/exit",
    type: "text",
    dataType: "number",
  },
  {
    name: "turning_curve_radius",
    title: "Please specify the radius of the turning curve",
    type: "text",
    dataType: "number",
  },
  {
    name: "non_turning_curve_radius",
    title: "Please specify the radius of the non-turning curve",
    type: "text",
    dataType: "number",
  },
  {
    name: "acceleration_width",
    title: "Please specify the width of the acceleration lane",
    type: "text",
    dataType: "number",
  },
  {
    name: "deceleration_width",
    title: "Please specify the width of the deceleration lane",
    type: "text",
    dataType: "number",
  },
  {
    name: "service_road_width",
    title: "Please specify the width of the service road",
    type: "text",
    dataType: "number",
  },
  // {
  //   name: "service_road_length",
  //   title: "Please specify the length of the service road (in metres)",
  //   type: "text",
  //   dataType: "number",
  // },
  {
    name: "access_road_downward_slope",
    title:
      "Please specify the access road slope towards the intercepting drain",
    type: "text",
    dataType: "number",
  },
  {
    name: "num_of_cultivates",
    title:
      "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
    type: "text",
    dataType: "number",
  },
  {
    name: "total_traffic_per_day",
    title: "Total traffic (incoming and outgoing) per day",
    type: "text",
    dataType: "number",
  },
];

// retail

export const ifUrbanSectionRetailNew: any[] = [
  {
    name: "distance_from_nearest_intersection",
    title:
      "Please specify the distance from the nearest intersection (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_toll_plaza",
    title:
      "Please specify the distance from the nearest toll plaza (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_start_rob",
    title:
      "Please specify the distance from the start of the Road Over Bridge (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "start_distance_from_flyover",
    title:
      "Please specify the distance from the start of the flyover / grade separator (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "carriageway_fs_distance",
    title:
      "Please specify the undivided carriageway distance from fuel station (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "divided_carriageway_distance_from_fs",
    title:
      "Please specify the divided carriageway distance from fuel station (in metres).",
    type: "text",
    dataType: "number",
  },
  {
    name: "service_road_width",
    title:
      "What is the length of the service road including deceleration and acceleration lanes (in metres)?",
    type: "text",
    dataType: "number",
  },
  {
    name: "land_acquired_extent",
    title: "Mention the extent of land acquisition required (in sq.m)",
    type: "text",
    dataType: "number",
  },
  {
    name: "highway_gradient_section",
    title: "Please specify the gradient of the highway section (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "fuel_station_slope_percentage",
    title: "Please specify the downward slope of the access road (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "buffer_strip_length",
    title: "Please specify the buffer strip length (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "buffer_strip_width",
    title: "Please specify the buffer strip width (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "kerb_height",
    title: "Please specify the kerb height (in mm)",
    type: "text",
    dataType: "number",
  },
  {
    name: "turning_curve_radius",
    title: "Please specify the turning curve radius (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "non_turning_curve_radius",
    title: "Please specify the non-turning curve radius (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "area_acquired",
    title:
      "Mention additional land acquisition required to be done by the owner of the fuel station (in sq.m):",
    type: "text",
    dataType: "number",
  },
  {
    name: "access_road_downward_slope",
    title: "Please specify the downward slope of the access road (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "nh_access_area_diff",
    title:
      "Please specify the vertical difference between NH and access area (in mm)",
    type: "text",
    dataType: "number",
  },
  {
    name: "num_of_cultivates",
    title:
      "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
    type: "text",
    dataType: "number",
  },
];

export const ifRuralSectionRetailNew: any[] = [
  {
    name: "acceleration_length",
    title: "Please specify the acceleration lane length (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "deceleration_length",
    title: "Please specify the deceleration lane length (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "nearest_intersection_length",
    title: "Please specify the nearest intersection length (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_toll_plaza",
    title: "Please specify the distance from the toll plaza (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_start_rob",
    title: "Please specify the distance from the start of the ROB (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "start_distance_from_flyover",
    title: "Please specify the start distance from the flyover (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "undivided_carriageway_distance_from_fs",
    title:
      "Please specify the undivided carriageway distance from fuel station (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "divided_carriageway_distance_from_fs",
    title:
      "Please specify the divided carriageway distance from fuel station (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "service_road_provision_length",
    title:
      "Length of the service road including deceleration and acceleration lanes (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "service_road_length",
    title: "Mention the extent of land acquisition required (in sq.m)",
    type: "text",
    dataType: "number",
  },
  {
    name: "land_acquired_extent",
    title: "Mention the extent of land acquisition required (in sq.m)",
    type: "text",
    dataType: "number",
  },
  {
    name: "highway_gradient_percent",
    title: "Please specify the highway gradient (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "slope_premise_percent",
    title: "Please specify the slope of the premises (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "buffer_strip_length",
    title: "Please specify the buffer strip length (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "buffer_strip_width",
    title: "Please specify the buffer strip width (in metres)",
    type: "text",
  },
  {
    name: "kerb_height",
    title: "Please specify the kerb height (in mm)",
    type: "text",
    dataType: "number",
  },
  {
    name: "turning_curve_radius",
    title: "Please specify the turning curve radius (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "non_turning_curve_radius",
    title: "Please specify the non-turning curve radius (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "area_acquired",
    title:
      "Mention the additional land acquisition required to be done by the owner of the fuel station. (in sq.m)",
    type: "text",
    dataType: "number",
  },
  {
    name: "access_road_downward_slope",
    title: "Please specify the downward slope of the access road (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "nh_access_area_diff",
    title:
      "Please specify the height difference between NH and access area (in mm)",
    type: "text",
    dataType: "number",
  },
  {
    name: "num_of_cultivates",
    title:
      "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
    type: "text",
    dataType: "number",
  },
];

export const ifHillySectionRetailNew: any[] = [
  {
    name: "distance_from_nearest_intersection",
    title:
      "Please specify the distance from the nearest intersection (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_toll_plaza",
    title:
      "Please specify the distance from the nearest toll plaza, railway level crossing, or check barrier (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "distance_from_start_rob",
    title:
      "Please specify the distance from the start of the Road Over Bridge (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "start_distance_from_flyover",
    title:
      "Please specify the distance from the start of the flyover / grade separator (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "carriageway_fs_distance",
    title:
      "Please specify the undivided carriageway distance from fuel station (in metres)",
    type: "text",
    dataType: "number",
  },
  // {
  //   name: "divided_carriageway_distance_from_fs",
  //   title:
  //     "Please specify the divided carriageway distance from fuel station (in metres).",
  //   type: "text",
  //   dataType: "number",
  // },
  {
    name: "service_road_length",
    title:
      "What is the length of the service road including deceleration and acceleration lanes (in metres)?",
    type: "text",
    dataType: "number",
  },
  {
    name: "land_acquired_extent",
    title: "Mention the extent of land acquisition required (in sq.m)",
    type: "text",
    dataType: "number",
  },
  {
    name: "highway_gradient_section",
    title: "Specify the gradient of the highway section (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "fuel_station_slope_percentage",
    title: "Please specify the downward slope of the access road (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "buffer_strip_length",
    title: "Please specify the buffer strip length (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "buffer_strip_width",
    title: "Please specify the buffer strip width (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "kerb_height",
    title: "Please specify the kerb height (in mm)",
    type: "text",
    dataType: "number",
  },
  {
    name: "turning_curve_radius",
    title: "Please specify the turning curve radius (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "non_turning_curve_radius",
    title: "Please specify the non-turning curve radius (in metres)",
    type: "text",
    dataType: "number",
  },
  {
    name: "area_acquired",
    title:
      "Mention additional land acquisition required to be done by the owner of the fuel station (in sq.m):",
    type: "text",
    dataType: "number",
  },
  {
    name: "access_road_downward_slope",
    title: "Please specify the downward slope of the access road (in %)",
    type: "text",
    dataType: "number",
  },
  {
    name: "nh_access_area_diff",
    title:
      "Please specify the vertical difference between NH and access area (in mm)",
    type: "text",
    dataType: "number",
  },
  {
    name: "num_of_cultivates",
    title:
      "Please enter the number of culverts or cross-drainage structures required to be widened or augmented.",
    type: "text",
    dataType: "number",
  },
];
